
export interface BreakEvenAmountsModel {
    streamingRatio: number;
    trackVsAlbumsRatio: number;
    digitalVsPhysicalRatio: number;
    // physicalAlbums: number;
}

export interface SpendAmountsModel {
    recording: number;
    marketing: number;
    manufacturing: number;
    admin: number;
    other: number;
}

export interface InfoModel {
    artistName: string;
    genre: string;
    format: string;
    doingPhysical: string;
    releaseName: string;

}

export interface BEOMStore {
    info: InfoModel;
    spend: SpendAmountsModel;
    breakEven: BreakEvenAmountsModel;
    rates: PricePerUnitRate,
}

export interface PricePerUnitRate {
    perStreamRate: number;
    digitalTrackPrice: number;
    digitalAlbumPrice: number;
    vinylAlbumPrice: number;
    cdAlbumPrice: number;
}


const emptyStore: BEOMStore = {
    info: {
        artistName: "",
        genre: "",
        format: "",
        doingPhysical: "",
        releaseName: "",
    },
    spend: {
        recording: 0,
        marketing: 0,
        manufacturing: 0,
        admin: 0,
        other: 0,
    },
    breakEven: {
        streamingRatio: 0,
        trackVsAlbumsRatio: 0,
        digitalVsPhysicalRatio: 0,
        // physicalAlbums: 0,
    },
    // defaults for now.. these will be loaded dynamically
    rates: {
        perStreamRate: 0.0062,
        digitalTrackPrice: 0.99,
        digitalAlbumPrice: 10.99,
        vinylAlbumPrice: 29.99,
        cdAlbumPrice: 12.99,
    },

}

export const testStore: BEOMStore = {
    info: {
        artistName: "test artist",
        genre: "EDM",
        format: "Single",
        doingPhysical: "Yep, vinyl",
        releaseName: "Testing 1234",
    },
    spend: {
        recording: 25000,
        marketing: 2400,
        manufacturing: 2500,
        admin: 1300,
        other: 11,
    },
    breakEven: {
        streamingRatio: 0.8,
        trackVsAlbumsRatio: 0.15,
        digitalVsPhysicalRatio: 0.03,
        // physicalAlbums: 0.02,
    },
    rates: {
        perStreamRate: 0.0062,
        digitalTrackPrice: 0.99,
        digitalAlbumPrice: 10.99,
        vinylAlbumPrice: 29.99,
        cdAlbumPrice: 12.99,
    }
}

export const defaultStore: BEOMStore = emptyStore;
